import {
    ConnectFlowModel,
    VueFlowConnectionModel,
    VueFlowNodeModel,
    SelectOptionsServiceGetConnectFlowAudiosResult,
    SelectOptionsServiceGetConnectFlowQueuesResult,
    SelectOptionsServiceGetConnectFlowSchedulesResult,
    SelectOptionsServiceGetConnectFlowSurveysResult,
    SelectOptionsServiceGetUserExtensionsResult,
    SelectOptionsServiceGetConnectFlowCustomsResult,
    NumberModel,
} from '@/types';

export interface ConnectFlowModelingMenu {
    show: boolean;
    action: string;
    idTriggerBy: string | null;
}
export interface ConnectFlowModelingState {
    connectFlow: ConnectFlowModel;
    elements: (VueFlowNodeModel | VueFlowConnectionModel)[];
    menu: ConnectFlowModelingMenu;
    scheduleOptions: SelectOptionsServiceGetConnectFlowSchedulesResult[];
    queueOptions: SelectOptionsServiceGetConnectFlowQueuesResult[];
    extensionsOptions: SelectOptionsServiceGetUserExtensionsResult[];
    audioOptions: SelectOptionsServiceGetConnectFlowAudiosResult[];
    surveyOptions: SelectOptionsServiceGetConnectFlowSurveysResult[];
    connectFlowCustomOptions: SelectOptionsServiceGetConnectFlowCustomsResult[];
    numberOptions: NumberModel[];
}

export enum ConnectFlowModelingMutations {
    SET_MENU = 'connectFlowModeling_setMenu',
    SET_MENU_TRIGGER_BY = 'connectFlowModeling_setMenuTriggerBY',
    SET_CONNECT_FLOW = 'connectFlowModeling_setConnectFlow',
    PUSH_NEW_ELEMENT = 'connectFlowModeling_setNewElement',
    SET_ELEMENTS = 'connectFlowModeling_setElements',
    SET_SCHEDULE_OPTIONS = 'connectFlowModeling_setSchedule',
    SET_QUEUE_OPTIONS = 'connectFlowModeling_setQueue',
    SET_SURVEY_OPTIONS = 'connectFlowModeling_setSurvey',
    SET_AUDIO_OPTIONS = 'connectFlowModeling_setAudio',
    SET_USER_EXTENSION_OPTIONS = 'connectFlowModeling_setExtension',
    SET_CONNECT_FLOW_CUSTOM_OPTIONS = 'connectFlowModeling_setConnectFlowCustom',
    UPDATE_ELEMENT = 'connectFlowModeling_updateElement',
    DELETE_ELEMENTS = 'connectFlowModeling_deleteElements',
}

export enum ConnectFlowModelingActions {
    SET_MENU = 'connectFlowModeling_setMenuShow',
    SET_ELEMENTS = 'connectFlowModeling_setElements',
    SET_CONNECT_FLOW = 'connectFlowModeling_setConnectFlow',
    PUSH_NEW_NODE = 'connectFlowModeling_pushNewNode',
    EDIT_NODE = 'connectFlowModeling_editNode',
    DELETE_NODE = 'connectFlowModeling_deleteNode',
    GO_TO_CONNECTION = 'connectFlowModeling_goToConnection',
    LOAD_FLOW_FLOW = 'connectFlowModeling_loadFLowFlow',
}

export enum ConnectFlowModelingGetters {
    MENU = 'connectFlowModeling_menu',
    CONNECT_FLOW = 'connectFlowModeling_connectFlow',
    ELEMENTS = 'connectFlowModeling_elements',
    ELEMENT_BY_ID = 'connectFlowModeling_elementById',
    ELEMENTS_NODES = 'connectFlowModeling_elementsNodes',
    ELEMENTS_CONNECTIONS = 'connectFlowModeling_elementsConnections',
    IS_ALL_ELEMENTS_VALID = 'connectFlowModeling_isAllElementsValid',
    SCHEDULE_OPTIONS = 'connectFlowModeling_scheduleOptions',
    AUDIO_OPTIONS = 'connectFlowModeling_audioOptions',
    QUEUE_OPTIONS = 'connectFlowModeling_queueOptions',
    SURVEY_OPTIONS = 'connectFlowModeling_surveyOptions',
    EXTENSION_OPTIONS = 'connectFlowModeling_extensionsOptions',
    CONNECT_FLOW_CUSTOM_OPTIONS = 'connectFlowModeling_connectFlowCustomOptions',
}
